// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.outcomes-automations-panel {
  display: block;
  margin-top: 16px;
  font-family: 'Inter', sans-serif;
  color: #181D27;
}
.outcomes-automations-panel__title {
  margin: 0 0 16px;
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.3;
  color: #252B37;
}
.outcomes-automations-panel__list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
/*# sourceMappingURL=OutcomesAndAutomationsPanel.css.map */`, "",{"version":3,"sources":["webpack://./OutcomesAndAutomationsPanel.less","webpack://./wp_components/Automations/components/OutcomesAndAutomationsPanel/OutcomesAndAutomationsPanel.less"],"names":[],"mappings":"AAEA;EACI,cAAA;EACA,gBAAA;EACA,gCAAA;EACA,cAAA;ACDJ;ADGI;EACI,gBAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;ACDR;ADII;EACI,aAAA;EACA,sBAAA;EACA,SAAA;ACFR;AACA,0DAA0D","sourcesContent":["@import '../../../../less/variables.less';\n\n.outcomes-automations-panel {\n    display: block;\n    margin-top: @padding-xl;\n    font-family: @font-body;\n    color: @fg-primary;\n\n    &__title {\n        margin: 0 0 @padding-xl;\n        font-family: @font-heading;\n        font-size: 18px;\n        font-weight: @font-weight-bold;\n        line-height: 1.3;\n        color: @heading-color;\n    }\n\n    &__list {\n        display: flex;\n        flex-direction: column;\n        gap: @padding-lg;\n    }\n}\n",".outcomes-automations-panel {\n  display: block;\n  margin-top: 16px;\n  font-family: 'Inter', sans-serif;\n  color: #181D27;\n}\n.outcomes-automations-panel__title {\n  margin: 0 0 16px;\n  font-family: 'Inter', sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 1.3;\n  color: #252B37;\n}\n.outcomes-automations-panel__list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n/*# sourceMappingURL=OutcomesAndAutomationsPanel.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
